import * as React from "react"

import { SKU_MANAGEMENT_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import SkuManagementPage from "./index"


export const SkuManagementRoutes = {
    path: SKU_MANAGEMENT_ROUTES.PATH,
    title: SKU_MANAGEMENT_ROUTES.TITLE,
    icon: 'barcode',
    iconWeight: 'light',
    element: <AppLayout />,
    description: SKU_MANAGEMENT_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <SkuManagementPage />, 
        index: true
    }]
}
